import React from "react";
import StatusBadge from "../../UI/statusBadge";
import { formatPrice } from "../../../utils/formatPrice";

const AddsOneProduct = ({ adds, currency_factor }) => {
  return (
    <div className="card rounded-3">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center ">
          <h4 className="font16">الإضافات المطلوبة</h4>
          {/* <button className="btn btn-primary">إضافة اختيار</button> */}
        </div>
        {adds.map((add) => (
          <div key={add.id}>
            <div className="d-flex align-items-center  mt-3 gap-2">
              <h4 className="font14 desc text-start">{add?.name} </h4>
              <StatusBadge status={add?.is_active ? "active" : ""} />
            </div>

            <p className="text-green">
              {add?.price
                ? `${formatPrice(currency_factor, add.price)} ${add.symbol_currency || ""}`
                : "___"}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AddsOneProduct;